import { isRTL } from './isRTL.js';
const targets = new Set();
const queuedTargets = new Set();
function processQueue() {
    queuedTargets.forEach(updateTarget);
    queuedTargets.clear();
}
export function addTarget(target, immediateEvaluation = false) {
    if (immediateEvaluation) {
        // If the `skapa-rtl` attribute needs to set before the first render. For example an animation is triggered immediately.
        updateTarget(target);
    }
    else {
        // Let's wait for the stack to finish configuring the elements and their styles before determining the writing direction of the target.
        queuedTargets.add(target);
        if (queuedTargets.size === 1) {
            queueMicrotask(processQueue);
        }
    }
    targets.add(target);
}
export function removeTarget(target) {
    target.removeAttribute('skapa-rtl');
    targets.delete(target);
}
function updateTarget(target) {
    target.toggleAttribute('skapa-rtl', isRTL(target));
}
let notificationDebounceID = -1;
export function notifyListeners() {
    // debounce the update as there may be multiple observers in the dom triggering this function
    cancelAnimationFrame(notificationDebounceID);
    notificationDebounceID = requestAnimationFrame(() => {
        Array.from(targets).map(updateTarget);
    });
}
